import { isString } from 'lodash';
import { parse } from 'qs';

export const useUrlIssueIdCheck = () => {
  const query = parse(location.search.substring(1));
  const pid = isString(query.pid) ? parseInt(query.pid, 10) : NaN;
  const projectId = isNaN(pid) ? null : pid;

  // eslint-disable-next-line spellcheck/spell-checker
  const issueTxt = query.issueid || query.issueId;
  const id = isString(issueTxt) ? parseInt(issueTxt, 10) : NaN;
  const issueId = isNaN(id) ? null : id;

  // eslint-disable-next-line spellcheck/spell-checker
  const commentTxt = query.commentid || query.commentId;
  const cid = isString(commentTxt) ? parseInt(commentTxt, 10) : NaN;
  const commentId = isNaN(cid) ? null : cid;


  // eslint-disable-next-line spellcheck/spell-checker
  const reminderTxt = query.reminderid || query.reminderId;
  const rid = isString(reminderTxt) ? parseInt(reminderTxt, 10) : NaN;
  const reminderId = isNaN(rid) ? null : rid;

  const source = query.source as string | undefined;

  return { projectId, issueId, commentId, source, reminderId };
};

const urlMap: any = {
  'kanban': '看板',
  'team': '团队',
  'roadmap': '路线图',
  'work/list': '工作列表',
  'work/table': '多维表格',
  'release': '版本',
  'dashboard': '工作台',
  'backlog': '规划迭代',
  'epic': '史诗列表'
};
//获取系统内部的地址
export const getSystemUrlSource = () => {
  const pathname = location.pathname;
  const source = Object.keys(urlMap).find(key => pathname.includes(key));
  return source ? urlMap[source] : undefined;
};
